import React from 'react'
import T from 'prop-types'
import { Stack, Typography } from '@mui/material'

export default function CarDetailsItem({
  title,
  value,
  extraValue,
  icon,
  titleContainerProps,
  titleProps,
  valueProps,
  iconProps,
  ...others
}) {
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      {...others}
      sx={{ py: 1, ...others?.sx }}
    >
      {(title || icon) && (
        <Stack direction="row" alignItems="center" {...titleContainerProps}>
          {icon && (
            <icon.type
              fontSize="small"
              {...iconProps}
              sx={{ mr: 1, ...iconProps?.sx }}
            />
          )}
          {title && (
            <Typography
              component="span"
              variant="body2"
              color="textSecondary"
              {...titleProps}
            >
              <span>{title}</span>
            </Typography>
          )}
        </Stack>
      )}
      <Typography variant="body2" color="textPrimary" {...valueProps}>
        {value}
      </Typography>
      {extraValue && (
        <div style={{ maxWidth: 200 }}>
          <Typography variant="body2" color="textPrimary" {...valueProps}>
            {extraValue}
          </Typography>
        </div>
      )}
    </Stack>
  )
}

CarDetailsItem.propTypes = {
  title: T.string,
  value: T.string,
  extraValue: T.string,
  icon: T.object,
  others: T.object,
  titleContainerProps: T.object,
  titleProps: T.object,
  valueProps: T.object,
  iconProps: T.object,
}
